"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var math = __importStar(require("mathjs"));
var utils_1 = require("../../../utils");
var calculations_1 = require("../../../utils/calculations");
var index_1 = require("../index");
var CannabinoidsResultsColumnFactory = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.solidDisplayUnits, solidDisplayUnits = _c === void 0 ? "ug/g" : _c, _d = _b.volumeDisplayUnits, volumeDisplayUnits = _d === void 0 ? "ug/mL" : _d, _e = _b.precision, precision = _e === void 0 ? 3 : _e;
    return ({
        accessor: function (row) {
            var _a;
            var result = utils_1.findAnalyteResults({
                rawName: row.parameter.referenceComponent.rawName,
            })(row.results.components);
            try {
                if (typeof (result === null || result === void 0 ? void 0 : result.final_amount) !== "number")
                    return "ND";
                if (result.final_amount <= (row.parameter.levelOfDetection || 0))
                    return "ND";
                if (result.final_amount <= (row.parameter.levelOfQuantitation || 0))
                    return "<LOQ";
                return utils_1.convertToDisplayUnits(math
                    .unit(calculations_1.correctForDensity(calculations_1.correctForMoisture((_a = result === null || result === void 0 ? void 0 : result.final_amount) !== null && _a !== void 0 ? _a : 0, row.moistureContentPercentage), row.density), utils_1.convertFromDisplayUnits((row.isSolid
                    ? row.parameter.weightUnitOfMeasure
                    : row.parameter.volumeUnitOfMeasure) || "ug/g"))
                    .to(row.isSolid ? solidDisplayUnits : volumeDisplayUnits)
                    .format({ notation: "fixed", precision: precision })
                    .toString()
                    .replace(" / ", "/"));
            }
            catch (err) {
                console.error("Error rendering in default results column", row, err);
                return "Error";
            }
        },
        Header: "Results",
        width: 50,
    });
};
var CannabinoidsResultsPercentageColumn = {
    accessor: function (row) {
        var result = utils_1.findAnalyteResults({
            rawName: row.parameter.referenceComponent.rawName,
        })(row.results.components);
        return typeof (result === null || result === void 0 ? void 0 : result.final_amount) === "number" &&
            (result === null || result === void 0 ? void 0 : result.final_amount) > (row.parameter.levelOfQuantitation || 0)
            ? calculations_1.convertPpmToPercent(calculations_1.correctForDensity(calculations_1.correctForMoisture(result === null || result === void 0 ? void 0 : result.final_amount, row.moistureContentPercentage), row.density))
                .toFixed(3)
                .toString() + "%"
            : "N/A";
    },
    Header: "Results (%)",
    width: 50,
};
var ResultPerServingColumnFactory = function (amountPerServing) { return ({
    Header: "mg per Serving",
    accessor: function (row) {
        var _a, _b;
        var result = utils_1.findAnalyteResults({
            rawName: row.parameter.referenceComponent.rawName,
        })(row.results.components);
        try {
            if (typeof (result === null || result === void 0 ? void 0 : result.final_amount) !== "number")
                return "ND";
            if (result.final_amount <= (row.parameter.levelOfDetection || 0))
                return "ND";
            if (result.final_amount <= (row.parameter.levelOfQuantitation || 0))
                return "<LOQ";
            if (!amountPerServing)
                return "N/A";
            return math
                .unit((_b = calculations_1.correctForDensity(calculations_1.correctForMoisture((_a = result === null || result === void 0 ? void 0 : result.final_amount) !== null && _a !== void 0 ? _a : 0, row.moistureContentPercentage), row.density) * (amountPerServing === null || amountPerServing === void 0 ? void 0 : amountPerServing.value)) !== null && _b !== void 0 ? _b : 0, "ug")
                .to("mg")
                .format({ notation: "fixed", precision: 2 })
                .toString();
        }
        catch (err) {
            console.error("Error rendering in result per serving column", row, err);
            return "Error";
        }
    },
    width: 50,
}); };
var ResultPerPackageColumnFactory = function (amountPerPackage) { return ({
    Header: "mg per Package",
    accessor: function (row) {
        var _a, _b;
        var result = utils_1.findAnalyteResults({
            rawName: row.parameter.referenceComponent.rawName,
        })(row.results.components);
        try {
            if (typeof (result === null || result === void 0 ? void 0 : result.final_amount) !== "number")
                return "ND";
            if (result.final_amount <= (row.parameter.levelOfDetection || 0))
                return "ND";
            if (result.final_amount <= (row.parameter.levelOfQuantitation || 0))
                return "<LOQ";
            if (!amountPerPackage)
                return "N/A";
            return math
                .unit((_b = calculations_1.correctForDensity(calculations_1.correctForMoisture((_a = result === null || result === void 0 ? void 0 : result.final_amount) !== null && _a !== void 0 ? _a : 0, row.moistureContentPercentage), row.density) * (amountPerPackage === null || amountPerPackage === void 0 ? void 0 : amountPerPackage.value)) !== null && _b !== void 0 ? _b : 0, "ug")
                .to("mg")
                .format({ notation: "fixed", precision: 2 })
                .toString();
        }
        catch (err) {
            console.error("Error rendering in result per serving column", row, err);
            return "Error";
        }
    },
    width: 50,
}); };
var columnsFactory = function (_a) {
    var _b = _a === void 0 ? {} : _a, amountPerPackage = _b.amountPerPackage, amountPerServing = _b.amountPerServing;
    return __spreadArrays([
        index_1.AnalyteColumn,
        index_1.LODColumnFactory({
            solidDisplayUnits: "mg/g",
            volumeDisplayUnits: "mg/mL",
        }),
        index_1.LOQColumnFactory({
            solidDisplayUnits: "mg/g",
            volumeDisplayUnits: "mg/mL",
        }),
        CannabinoidsResultsColumnFactory({
            solidDisplayUnits: "mg/g",
            volumeDisplayUnits: "mg/mL",
            precision: 2,
        }),
        CannabinoidsResultsPercentageColumn
    ], (amountPerServing
        ? [ResultPerServingColumnFactory(amountPerServing)]
        : []), (amountPerPackage
        ? [ResultPerPackageColumnFactory(amountPerPackage)]
        : []));
};
exports.default = columnsFactory;
//# sourceMappingURL=columns.js.map